export const initialErrors = {
  titleMain: String() || null,
  titleEn: String() || null,
  sortOrder: String() || null,
};

export const initialProvince = {
  titleMain: String(),
  titleEn: String(),
  sortOrder: 0,
};

export type initialProvinceType = typeof initialProvince;
export type initialErrorsType = typeof initialErrors;

export const provincesTableHead = [
  {
    id: 'titleMain',
    numeric: true,
    label: 'Title (Main)',
  },
  {
    id: 'titleEn',
    numeric: true,
    label: 'Title (English)',
  },
  {
    id: 'sortOrder',
    numeric: true,
    label: 'Sort Order',
  },
  {
    id: 'isActive',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: true,
    label: 'Created At',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];
